<template>
  <v-container v-if="merchantLoaded">
    <div mb-2 class=" d-flex justify-content-between grey lighten-4 pa-2">
      <div class="d-flex align-center">
        <h2>
          <router-link to="/merchants">Merchants</router-link>
          <span class="grey--text">&gt;</span>
          {{ merchant.name }} <span class="grey--text">(</span>{{ merchant.id
          }}<span class="grey--text">)</span>
        </h2>
      </div>
      <MerchantImageManagment :merchant="merchant" />
    </div>

    <v-layout row wrap>
      <v-flex xs6 sm2 class="primary--text font-weight-black pa-1"
        >Email:</v-flex
      >
      <v-flex xs6 sm4 pa-1>{{ merchant.email }}</v-flex>

      <v-flex xs6 sm2 class="primary--text font-weight-black pa-1"
        >Contact Name:</v-flex
      >
      <v-flex xs6 sm4 pa-1>{{ merchant.contact_name }}</v-flex>

      <v-flex
        xs6
        sm2
        class="primary--text font-weight-black pa-1"
        id="sales-rep-label"
      >
        Sales Representative:
      </v-flex>
      <v-flex xs6 sm4 class="pa-1">
        <v-select
          v-model="selectedSalesRepId"
          :items="salesReps"
          item-text="name"
          item-value="id"
          hide-details
          density="compact"
          clearable
          aria-labelledby="sales-rep-label"
        />
      </v-flex>

      <v-flex xs6 sm2 class="primary--text font-weight-black pa-1"
        >Processor:</v-flex
      >
      <v-flex xs6 sm4 pa-1>{{ merchant.processor_name }}</v-flex>

      <template v-if="merchant.parent_account_id">
        <v-flex xs6 sm2 class="primary--text font-weight-black pa-1"
          >Parent:</v-flex
        >
        <v-flex xs6 sm4 pa-1>
          <router-link
            :to="{
              name: 'Merchant',
              params: { id: merchant.parent_account_id }
            }"
          >
            {{ merchant.parent_name }}
          </router-link>
        </v-flex>
      </template>

      <v-flex xs6 sm2 class="primary--text font-weight-black pa-1"
        >Email:</v-flex
      >
      <v-flex xs6 sm4 pa-1>{{ merchant.email }}</v-flex>

      <v-flex xs6 sm2 class="primary--text font-weight-black pa-1"
        >Website:</v-flex
      >
      <v-flex xs6 sm4 pa-1>{{ merchant.website }}</v-flex>

      <v-flex xs6 sm2 class="primary--text font-weight-black pa-1"
        >Manager Password:</v-flex
      >
      <v-flex xs6 sm4 pa-1>{{ merchant.manager_password }}</v-flex>

      <v-flex xs6 sm2 class="primary--text font-weight-black pa-1"
        >Timezone:</v-flex
      >
      <v-flex xs6 sm4 pa-1>{{ merchant.timezone }}</v-flex>

      <v-flex xs6 sm2 class="primary--text font-weight-black pa-1"
        >Enabled:</v-flex
      >
      <v-flex xs6 sm4>
        <v-chip
          small
          :class="
            !merchant.is_active
              ? 'error lighten-5 pa-1 error--text text--darken-3 font-weight-black'
              : 'success lighten-5 pa-1 success--text text--darken-4 font-weight-black'
          "
        >
          <v-icon v-if="!merchant.is_active" class="mr-2">fa-times</v-icon>
          <v-icon v-if="merchant.is_active" class="mr-2">fa-check</v-icon>
          {{
            merchant.is_active
              ? "Yes (Account Enabled)"
              : "No (Account Disabled)"
          }}
        </v-chip>
      </v-flex>

      <v-flex xs6 sm2 class="primary--text font-weight-black pa-1">ISO:</v-flex>
      <v-flex xs6 sm4 :class="merchant.is_iso ? 'success pa-1' : 'pa-1'">{{
        merchant.is_iso ? "Yes" : "No"
      }}</v-flex>

      <v-flex xs6 sm2 class="primary--text font-weight-black pa-1"
        >Cash Discount:</v-flex
      >
      <v-flex xs6 sm4 pa-1>{{
        merchant.is_cashdiscount ? "Yes" : "No"
      }}</v-flex>

      <v-flex xs6 sm2 class="primary--text font-weight-black pa-1"
        >Created:</v-flex
      >
      <v-flex xs6 sm4 pa-1>{{ datetime(merchant.created) }}</v-flex>

      <v-flex xs6 sm2 class="primary--text font-weight-black pa-1"
        >Modified:</v-flex
      >
      <v-flex xs6 sm4 pa-1>{{ datetime(merchant.modified) }}</v-flex>
    </v-layout>

    <v-divider class="primary"></v-divider>

    <v-layout row wrap>
      <v-flex xs6 sm2 class="primary--text font-weight-black pa-1"
        >Address:</v-flex
      >
      <v-flex xs6 sm4 pa-1>{{ merchant.street_1 }}</v-flex>

      <v-flex xs6 sm2 class="primary--text font-weight-black pa-1"
        >Address:</v-flex
      >
      <v-flex xs6 sm4 pa-1>{{ merchant.street_2 }}</v-flex>

      <v-flex xs6 sm2 class="primary--text font-weight-black pa-1"
        >City:</v-flex
      >
      <v-flex xs6 sm4 pa-1>{{ merchant.city }}</v-flex>

      <v-flex xs6 sm2 class="primary--text font-weight-black pa-1"
        >State:</v-flex
      >
      <v-flex xs6 sm4 pa-1>{{ merchant.state }}</v-flex>

      <v-flex xs6 sm2 class="primary--text font-weight-black pa-1"
        >Postal Code:</v-flex
      >
      <v-flex xs6 sm4 pa-1>{{ merchant.zip }}</v-flex>

      <v-flex xs6 sm2 class="primary--text font-weight-black pa-1"
        >Phone:</v-flex
      >
      <v-flex xs6 sm4 pa-1>{{ phone(merchant.phone) }}</v-flex>
    </v-layout>

    <v-divider class="primary"></v-divider>

    <v-expansion-panel v-model="panel" expand multiple class="elevation-0">
      <v-expansion-panel-content>
        <div slot="header" class="title font-weight-medium">
          Notes
        </div>
        <v-card>
          <v-card-text>
            {{ merchant.notes }}
          </v-card-text>

          <v-card-actions> </v-card-actions>
        </v-card>
      </v-expansion-panel-content>

      <v-expansion-panel-content>
        <div slot="header" class="title font-weight-medium">
          Permissions
        </div>
        <vue-json-pretty :data="merchant.permissions"></vue-json-pretty>
      </v-expansion-panel-content>

      <v-expansion-panel-content>
        <div slot="header" class="title font-weight-medium">
          MIDS
        </div>
        <v-card>
          <v-card-text>
            <v-alert v-if="!mids.length" type="info" :value="true">No MIDs found for this account.</v-alert>
            <v-layout v-for="mid in mids" :key="mid.type + mid.mid" row align-center class="mb-2">
              <v-flex shrink>
                <strong>{{ mid.type === 'pnx' ? 'PNX MID' : 'FPG MID' }}:</strong>
              </v-flex>
              <v-flex class="ml-2">{{ mid.mid }}</v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>

      <v-expansion-panel-content>
        <div slot="header" class="title font-weight-medium">
          Terminals
        </div>
        <Terminals
          ref="terminals"
          :accountId="merchant.id"
          v-if="merchant.id"
        ></Terminals>
      </v-expansion-panel-content>

      <v-expansion-panel-content>
        <div slot="header" class="title font-weight-medium">
          Users
        </div>
        <Users ref="users" :accountId="merchant.id" v-if="merchant.id"></Users>
      </v-expansion-panel-content>

      <v-expansion-panel-content>
        <div slot="header" class="title font-weight-medium">
          Chargebacks
        </div>
        <Chargebacks
          ref="chargebacks"
          :accountId="merchant.id"
          v-if="merchant.id"
        ></Chargebacks>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-layout row wrap class="mt-5">
      <v-flex>
        <div class="d-flex justify-start">
          <v-btn
            style="max-width: 275px;"
            round
            @click="migrateFunction"
            color="info"
          >
            Migrate Merchant
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs6>
        <div class="d-flex justify-end">
          <v-btn
            style="max-width: 275px;"
            round
            @click="modifyMerchant"
            color="primary"
            :disabled="!merchant.is_active ? true : false"
          >
            Save Merchant Account Changes
          </v-btn>
        </div>

        <div class="d-flex justify-end">
          <v-btn
            v-if="merchant.is_active"
            style="max-width: 275px;"
            round
            @click="closeMerchant"
            color="error"
          >
            <v-icon class="mr-2 error--text text--darken-4">fa-times</v-icon>
            Close Merchant Account
          </v-btn>
          <v-btn
            v-if="!merchant.is_active"
            style="max-width: 275px;"
            round
            @click="reopenMerchant"
            color="success"
          >
            <v-icon class="mr-2 success--text text--darken-4">fa-check</v-icon>
            Reopen Merchant Account
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
    
  </v-container>
</template>

<script>
import Bus from '@/bus'

import Chargebacks from '@/components/transactions/Chargebacks'
import Terminals from '@/components/manage/Terminals'
import Users from '@/components/manage/Users'
import VueJsonPretty from '@/components/VueJsonPrettyWrapper'
import MerchantImageManagment from './MerchantImageManagement.vue'

import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import DisplayMixin from '@/mixins/display'
import StoreMixin from '@/store/mixin'

export default {
  components: {
    Chargebacks,
    Terminals,
    Users,
    VueJsonPretty,
    MerchantImageManagment
  },
  mixins: [ApiMixin, AuthMixin, DisplayMixin, StoreMixin],

  data: function () {
    return {
      panel: [false, false, false, false, false],
      merchant: {},
      mids: [],
      terminals: [],
      users: [],
      merchantLoaded: false,
      salesReps: [],
      selectedSalesRepId: null
    }
  },

  mounted () {
    this.load()
  },

  methods: {
    async load () {
      Bus.$emit('openWaitModal')

      try {
        if (!this.$route.params.id) {
          throw new Error('Invalid merchant')
        }

        let merchants = await this.api({
          url: `/accounts/${this.$route.params.id}`
        })

        this.merchant = merchants.data.account
        this.merchantLoaded = true

        let midsResult = await this.api({
          url: `/accounts/${this.$route.params.id}/mids`
        })
        this.mids = midsResult.data.mids

        const salesReps = await this.getAccountSalesReps()
        this.salesReps = salesReps.data.rows

        const assignedRepNames = this.merchant.sales_rep_names
          ? this.merchant.sales_rep_names.split(',').map(name => name.trim())
          : []

        const assignedRep = this.salesReps.find(rep =>
          assignedRepNames.includes(rep.name)
        )

        this.selectedSalesRepId = assignedRep ? assignedRep.id : null
      } catch (error) {
        Bus.$emit('openModal', { status: 'error', message: error })
      } finally {
        Bus.$emit('closeWaitModal')
      }
    },
    async getAccountSalesReps () {
      let result = await this.api({
        method: 'get',
        url: '/users',
        params: {
          filter: {
            position: 'Account Rep',
            enabled: '1'
          }
        }
      })
      return result
    },
    async modifyMerchant () {
      try {
        if (window.confirm('Do you wish to modify this account.')) {
          Bus.$emit('openWaitModal')
          await this.api({
            url: `/accounts/${this.merchant.id}/modify`,
            method: 'put',
            data: {
              sales_rep_id: this.selectedSalesRepId
            }
          })
        }
      } catch (error) {
        Bus.$emit('openModal', { status: 'error', message: error })
      } finally {
        Bus.$emit('closeWaitModal')
      }

      try {
        this.merchantLoaded = false
        await this.load()
        this.merchantLoaded = true
      } catch (error) {
        console.error('Error Refreshing Merchant Data: ', error)
      }
    },
    async closeMerchant () {
      let filter = {}
      filter.merchant_id = this.merchant.id
      try {
        if (window.confirm('Do you wish to close this account.')) {
          Bus.$emit('openWaitModal')
          await this.api({
            url: `/accounts/${this.merchant.id}/close`,
            method: 'put',
            data: {
              id: this.merchant.id
            }
          })
        }
      } catch (error) {
        Bus.$emit('openModal', { status: 'error', message: error })
      } finally {
        Bus.$emit('closeWaitModal')
      }

      try {
        this.merchantLoaded = false
        await this.load()
        this.merchantLoaded = true
      } catch (error) {
        console.error('Error Refreshing Merchant Data: ', error)
      }
    },
    async reopenMerchant () {
      try {
        if (window.confirm('Do you wish to reopen this account?')) {
          Bus.$emit('openWaitModal')
          await this.api({
            url: `/accounts/${this.merchant.id}/reopen`,
            method: 'put',
            data: {
              id: this.merchant.id
            }
          })
        }
      } catch (error) {
        Bus.$emit('openModal', { status: 'error', message: error })
      } finally {
        Bus.$emit('closeWaitModal')
      }

      try {
        this.merchantLoaded = false
        await this.load()
        this.merchantLoaded = true
      } catch (error) {
        console.error('Error Refreshing Merchant Data: ', error)
      }
    },
    async migrateFunction() {
      const hasPnxAccount = this.mids.some(mid => mid.type === 'pnx')
      if (hasPnxAccount) {
        Bus.$emit('openModal', {
          status: 'error',
          message: 'A PayNetworx account already exists for this merchant.'
        })
        return
      }

      let result = await this.api({
        method: "post",
        url: `/accounts/migrate/${this.merchant.id}`,
        data: {}
      });
      return result;
    }
  }
}
</script>

<style lang="less">
.v-expansion-panel__container {
  margin: 5px;
}
.v-expansion-panel__header {
  background: var(--v-secondary-base) !important;
  padding: 5px;
}

.overflow-button {
  padding-bottom: 20px;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 20px;
}

.overflow-button .v-btn__content span {
  overflow: hidden;
  text-overflow: ellipsis !important;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/manage/Merchant.vue